import { IFormActions } from '../../@types/entityTypes';
import { useDispatch } from 'react-redux';
import { useComponentQueryErrorHandling } from '../../utils/parseErrorResponse';
import { useMutation } from '@apollo/client';
import SystemSmtpConfigTestEmailMutation from '../../graphql/mutations/system/SystemSmtpConfigTestEmailMutation.graphql';
import getClientMutationId from '../../utils/getClientMutationId';
import { serviceActions } from '../../state/modules/service';
import { AlertType } from '../../graphql/schema/p4types';
import { ActionButton } from '../../components/connectedForm/Button/Button';
import React, { useContext } from 'react';
import ConnectedFormContext from '../../components/Context/ConnectedFormContext';
import { usePerformSave } from '../../components/connectedForm/Hooks/usePerformSave';

export enum SmtpConfigAction {
  SendTestEmail = 'SendTestEmail',
}

const SendTestEmailAction = () => {
  const connectedForm = useContext(ConnectedFormContext);
  const { values } = connectedForm;
  const [performSave] = usePerformSave(() => {
    sendTestEmail();
  });

  const dispatch = useDispatch();

  const handleQueryError = useComponentQueryErrorHandling();
  const [sendTestEmailMutation] = useMutation(SystemSmtpConfigTestEmailMutation, {
    onError: handleQueryError,
  });

  const sendTestEmail = () => {
    const address = prompt('Recipient address?');

    if (!address || address.length === 0) {
      return;
    }

    sendTestEmailMutation({
      variables: {
        input: {
          clientMutationId: getClientMutationId(),
          id: values!.id,
          address,
        },
      },
    })
      .then((response) => {
        if (response.data) {
          dispatch(serviceActions.genericAlert('Email sent', 'Test email sent', AlertType.Success));
        }
      })
      .catch(handleQueryError);
  };

  return (
    <ActionButton label="Send Test Email" onClick={() => performSave({ submitMeta: { suppressAfterSubmit: true } })} />
  );
};

export const formActions: IFormActions<SmtpConfigAction> = [
  {
    actionReference: SmtpConfigAction.SendTestEmail,
    element: <SendTestEmailAction />,
    performSave: true,
  },
];
